"use strict";
exports.__esModule = true;
exports.AuthenticationMethodType = void 0;
var AuthenticationMethodType;
(function (AuthenticationMethodType) {
    AuthenticationMethodType[AuthenticationMethodType["GitHub"] = 1] = "GitHub";
    AuthenticationMethodType[AuthenticationMethodType["Google"] = 2] = "Google";
    AuthenticationMethodType[AuthenticationMethodType["Facebook"] = 3] = "Facebook";
    AuthenticationMethodType[AuthenticationMethodType["LinkedIn"] = 4] = "LinkedIn";
    AuthenticationMethodType[AuthenticationMethodType["Password"] = 5] = "Password";
})(AuthenticationMethodType = exports.AuthenticationMethodType || (exports.AuthenticationMethodType = {}));
